/* eslint-disable eqeqeq */
import {
  CmpButton,
  CmpSelectBox,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import Radio from "@mui/material/Radio";
import "./PriceEnquiry.css";
import {
  itemEnquiry_GETROW,
  itemEnquiryAttributes_GETROW,
} from "../../Server/ApiV2";
import { ItemList } from "./processComponent/ItemList";
import Breadcrumbs from "./processComponent/BreadCrumbs";
import { vRdxUserInfo } from "../../Redux/roStore";
import GCStockDetail from "./processComponent/GCStockDetails";

export default function PriceEnquiry() {
  const LocFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  // const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  // eslint-disable-next-line no-unused-vars
  const [sLocation, setLoc] = useState([]);
  const [sLoadObj, setLoadObj] = useState({
    loc: "",
    Barcode: "",
  });
  const [sModal, setModal] = useState(false);
  const [sGridrows, setGridrows] = useState([
    // {
    //   "Barcode": "101421",
    //   "ItmCd": "101421",
    //   "Name2": "POTATO (LOCAL)",
    //   "Unit": "KGS",
    //   "Packing": "KGS",
    //   "Costpr": 2.25,
    //   "SellPr1": 2.3333,
    //   "PackQty": 1,
    //   "StkQty": 0,
    //   "StkVal": 0,
    //   "SuppRefNo1": "101421",
    //   "MainSupplier": "CA0378",
    //   "MainSupplierName": "AL MADINA FRESH",
    //   "LpRate": 2.25,
    //   "TaxPerc": 5,
    //   "TaxPerc2": 0,
    //   "AddCessAmt": 0
    // }
  ]);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));

    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sLoadObj.Barcode.toString().length &&
      vMediaQuery &&
      e.target.name === "Barcode"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "" && vMediaQuery) {
        fOnKeyUp(vBackspaceObj);
      }
    }
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      GetSummaryList(sLoadObj.Barcode, sLoadObj.loc);
    } else if (e.key === "Backspace") {
      setLoadObj((obj) => ({
        ...obj,
        Barcode: "",
      }));
      setGridrows([]);
    }
  };

  const fOnChangeSelect = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    GetSummaryList(sLoadObj.Barcode, e.target.value);
  };
  // const fLoad = async (e) => {
  //   setLoadObj((obj) => ({
  //     ...obj,
  //     loc: vRdxuserLoc[0]?.UID,
  //   }));
  //   GetSummaryList(  sLoadObj.code, vRdxuserLoc[0]?.UID);
  // };

  //API BIN_ENQUIRY_GETROW
  const GetSummaryList = async (xcode, xloc) => {
    let payload = {
      v_Barcode: xcode || "",
      v_Loc: xloc,
    };
    // let payload = {
    //   v_Barcode:101421,
    //   v_Loc: "05",
    // };

    let resp = await itemEnquiry_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData = resp?.data?.ResultSet;
      if (resp?.data?.ResultSet.length > 0) {
        setLoadObj((obj) => ({
          ...obj,
          Barcode: "",
        }));
      }
      setGridrows(respData);
    } else {
      setGridrows([]);
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg || "error in price enquiry "
        );
      }
    }
  };
  const GetAttributes = async (setLoc) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vObj = {
      userCode: vRdxUserInfoObj.UserID,
    };
    const iAttributes = await itemEnquiryAttributes_GETROW(vObj);

    console.log(iAttributes);

    if (iAttributes?.status === 200) {
      setLoc(iAttributes?.data?.ResultSet?.Loc);
      return iAttributes?.data?.ResultSet;
    } else {
      return [];
    }
  };

  const fLoad = async () => {
    // itemEnquiryAttributes_GETROW
    let iAttributeResp = await GetAttributes(setLoc);
    let vLoc = iAttributeResp?.Loc;
    // let iLocObj = {
    //   UID: "",
    //   Name1: "",
    //   BatchCtrl: "",
    //   Br: "",
    //   BrName: "",
    //   MBCDSearch: "",
    // };
    if (iAttributeResp?.Loc.length > 0) {
      // vLoc = iAttributeResp?.Loc[0];
      setLoadObj((obj) => ({
        ...obj,
        loc: iAttributeResp?.Loc[0].UID,
      }));
      // GetSummaryList(  sLoadObj.Barcode, iAttributeResp?.Loc[0].UID);
    }
  };

  useEffect(() => {
    fLoad();
  }, []);

  useEffect(() => {
    LocFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Instant-picking-head">
        <div className="Breadcrumbs ">
          {/* eslint-disable-next-line react/jsx-pascal-case */}
          <Breadcrumbs />
        </div>
        <Grid container spacing={2} >
          <Grid item lg={2} md={3} xs={12}>
            <CmpSelectBox
              xsize="small"
              xLabelText="Location"
              xValue={sLoadObj.loc}
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"loc"}
              xData={sLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={3} xs={12}>
            <CmpTextFieldEnter
              xSize="small"
              xref={LocFocusOnLoad}
              xLabelText={"Barcode"}
              xVariant={"outlined"}
              xValue={sLoadObj.Barcode}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"Barcode"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
            />
          </Grid>
          <Grid item lg={"auto"} md={"auto"} xs={12}>
            <CmpButton
              xbtnName="Stock Enquiry"
              xWidth="100%"
              xOnClick={(e) => {
                if (
                  sGridrows[0]?.ItmCd == "" ||
                  sGridrows[0]?.ItmCd == null ||
                  ""
                ) {
                  fAlertToast("INFO", "Item code should not be empty");
                  return;
                } else {
                  setModal(true);
                }
              }}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
            />
          </Grid>
        </Grid>

        <ItemList item={sGridrows.length > 0 ? sGridrows[0] : {}} />
        <GCStockDetail
          open={sModal}
          fCloseSearchModal={() => {
            setModal(false);
          }}
          xTitle={"Stock Enquiry"}
          v_itmCd={sGridrows.length > 0 ? sGridrows[0]?.ItmCd : ""}
        />
      </div>
    </div>
  );
}
